// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import { CookiesProvider } from 'react-cookie';

// core styles
import "./scss/volt.scss";

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import AudioPlayer from './components/AudioPlayer'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { clientIcon } from './helper/config';

const root = createRoot(document.getElementById("root"));

const resolvePublicAssetUrl = (path) => {
  if (!path) {
    return '/favicon.ico'
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${process.env.PUBLIC_URL || ''}${normalizedPath}`
}

const upsertFavicon = () => {
  const iconHref = resolvePublicAssetUrl(clientIcon)
  let faviconLink = document.querySelector("link[rel='icon']")
  if (!faviconLink) {
    faviconLink = document.createElement('link')
    faviconLink.rel = 'icon'
    document.head.appendChild(faviconLink)
  }
  faviconLink.href = iconHref
}

upsertFavicon()

root.render(
  <CookiesProvider>
    <BrowserRouter>
      <>
        <HomePage />
        <ToastContainer />
        <AudioPlayer url={require('./assets/audio/withdraw_bank.mp3')} tagId="withdraw" />
        <AudioPlayer url={require('./assets/audio/charge_issue.mp3')} tagId="chargeIssue" />
        <AudioPlayer url={require('./assets/audio/keno_new.mp3')} tagId="keno" />
        <AudioPlayer url={require('./assets/audio/mega_new.mp3')} tagId="mega" />
        <AudioPlayer url={require('./assets/audio/max3d_new.mp3')} tagId="max3d" />
        <AudioPlayer url={require('./assets/audio/max3dpro_new.mp3')} tagId="max3dpro" />
        <AudioPlayer url={require('./assets/audio/power_new.mp3')} tagId="power" />
        <AudioPlayer url={require('./assets/sounds/beer_can_opening.mp3')} tagId="beer" />
      </>
    </BrowserRouter>
  </CookiesProvider>
);
